import { churchesApi } from '../api/churchesApi'

export const deleteChurch = async (churchId: string) => {
  try {
    const { data } = await churchesApi.deleteChurch(churchId)
    return data
  } catch (error) {
    console.error(`Error deleting church: `, error)
    throw error
  }
}
